import { sectionRenderer } from '@theme/section-renderer';

/**
 * AJAX category pills on collection pages — morph header + main-collection.
 * Filters/sort stay on Fabric facets.js.
 */

function getSectionIdFromEl(el) {
  if (!el) return null;
  if (el.dataset.sectionId) return el.dataset.sectionId;
  const section = el.closest('.shopify-section');
  if (!section?.id) return null;
  return section.id.replace(/^shopify-section-/, '');
}

function findMainSectionId() {
  const main = document.querySelector('[data-w1gk-shop-main]');
  return getSectionIdFromEl(main);
}

function findHeaderSectionId() {
  const header = document.querySelector('[data-w1gk-shop-header]');
  return getSectionIdFromEl(header);
}

/**
 * Force size (short-label) filters to stay open inline like the mockup.
 */
function expandInlineSizeFilters(root = document) {
  const items = root.querySelectorAll(
    '.w1gk-shop-results accordion-custom.facets__item, .w1gk-shop-results .facets__item'
  );

  items.forEach((item) => {
    const param = (item.getAttribute('data-filter-param-name') || '').toLowerCase();
    const details = item.querySelector('details.facets__panel');
    if (!details) return;

    const hasPills = Boolean(details.querySelector('.facets__inputs-list--grid, .facets__pill-label'));
    const isSize = param.includes('rozmiar') || param.includes('size') || /option/.test(param);

    if (!hasPills && !isSize) return;
    if (param.includes('availability') || param.includes('boolean')) return;

    item.classList.add('w1gk-facets-item--inline');
    details.open = true;

    const summary = details.querySelector('summary');
    if (summary && !summary.dataset.w1gkInlineBound) {
      summary.dataset.w1gkInlineBound = '1';
      summary.addEventListener('click', (e) => {
        e.preventDefault();
        details.open = true;
      });
    }
  });
}

let expandScheduled = false;
function scheduleExpandInlineSizeFilters() {
  if (expandScheduled) return;
  expandScheduled = true;
  requestAnimationFrame(() => {
    expandScheduled = false;
    expandInlineSizeFilters();
  });
}

async function navigateCollection(url, { push = true } = {}) {
  const target = url instanceof URL ? url : new URL(url, window.location.origin);
  target.search = '';
  target.hash = '';

  const headerId = findHeaderSectionId();
  const mainId = findMainSectionId();
  if (!mainId) {
    window.location.href = target.pathname;
    return;
  }

  document.body.classList.add('w1gk-shop-loading');

  try {
    const jobs = [sectionRenderer.renderSection(mainId, { cache: false, url: target })];
    if (headerId) {
      jobs.push(sectionRenderer.renderSection(headerId, { cache: false, url: target }));
    }
    await Promise.all(jobs);

    if (push) {
      history.pushState({ w1gkShop: true }, '', target.pathname);
    }

    expandInlineSizeFilters();
  } catch (_) {
    window.location.href = target.pathname;
    return;
  } finally {
    document.body.classList.remove('w1gk-shop-loading');
  }
}

document.addEventListener('click', (event) => {
  const pill = event.target.closest('[data-w1gk-shop-pill]');
  if (!pill) return;
  if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  if (pill.getAttribute('target') === '_blank') return;

  const href = pill.getAttribute('href');
  if (!href || href === '#') return;

  const url = new URL(href, window.location.origin);
  if (url.origin !== window.location.origin) return;
  if (!url.pathname.includes('/collections/')) return;

  if (url.pathname === window.location.pathname && !url.search) {
    event.preventDefault();
    return;
  }

  event.preventDefault();
  navigateCollection(url, { push: true });
});

window.addEventListener('popstate', () => {
  if (!document.querySelector('[data-w1gk-shop-header], [data-w1gk-shop-main]')) return;
  navigateCollection(new URL(window.location.href), { push: false });
});

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => expandInlineSizeFilters());
} else {
  expandInlineSizeFilters();
}

document.addEventListener('shopify:section:load', () => expandInlineSizeFilters());
document.addEventListener('filter:update', () => scheduleExpandInlineSizeFilters());

const mo = new MutationObserver(() => {
  if (!document.querySelector('.w1gk-shop-results')) return;
  scheduleExpandInlineSizeFilters();
});
mo.observe(document.documentElement, { childList: true, subtree: true });
